import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
  mainPagePetInfoClickEvent,
  findPetInfoBtnClickEvent,
  aboutPagePetInfoClickEvent
} from '../../utils/ga4-events'
import './style.scss'

class Pet extends Component {
  render() {
    const {
      type,
      link,
      image,
      name,
      sex,
      age,
      sexOnClick,
      ageOnClick,
      closeOnClick,
      contacts,
      status,
      currentPage
    } = this.props

    const title = (
      <h5 className={`pet__name ${currentPage ? 'pet__title' : ''}`}>{name}</h5>
    )
    const badges = (
      <div className="pet__badges">
        <div
          className={`pet__badge ${
            sex === 'Мальчик' ? 'pet__badge_male' : 'pet__badge_female'
          } ${sexOnClick !== undefined ? 'pet__badge_hover' : ''}`}
          onClick={sexOnClick}
        >
          <i className="icon" /> {sex}
        </div>
        <div
          className={`pet__badge pet__badge_calendar ${
            ageOnClick !== undefined ? 'pet__badge_hover' : ''
          }`}
          onClick={ageOnClick}
        >
          <i className="icon" /> {age}
        </div>
      </div>
    )
    const badgesHome = (
      <div class="pet-with-owner">
        <img
          src={require('../pagesSections/currentPetSection/home-ico.svg')}
          alt=""
        />
        Уже дома!
      </div>
    )
    const badgesReserve = (
      <div class="pet-with-reserve">
        <span className="pet-with-reserve__lable">Забронирован</span>
      </div>
    )
    const handleClickEvent = () => {
      if (currentPage === 'main') mainPagePetInfoClickEvent(link)
      if (currentPage === 'about') aboutPagePetInfoClickEvent(link)
    }

    return (
      <div
        className={`pet ${this.props.className ? this.props.className : ''}`}
        style={{ backgroundImage: `url(${image})` }}
      >
        {type === 'catalog' ? (
          <div className="pet__inner">
            <Link
              to={link}
              className="pet__link pet__under-none"
              onClick={() => findPetInfoBtnClickEvent(link)}
            >
              {status === 'Активный' ? (
                <>
                  {title}
                  {badges}
                </>
              ) : null}
              {status === 'Пристроен' ? (
                <>
                  {title}
                  {badgesHome}
                </>
              ) : null}
              {status === 'Забронирован' ? (
                <>
                  {title}
                  {badgesReserve}
                </>
              ) : null}
            </Link>
          </div>
        ) : type === 'main' ? (
          <div className="pet__inner" onClick={() => handleClickEvent()}>
            <Link to={link} className="pet__link">
              {title}
            </Link>
            {badges}
          </div>
        ) : type === 'lk' ? (
          <div className="pet__inner">
            <Link to={link} className="pet__link">
              <div className="pet__close">
                <div className="icon icon-close" onClick={closeOnClick} />
              </div>
              {title}
              {contacts !== '' ? (
                <div className="pet__contacts">
                  <div className="pet__fund">{contacts.fond}</div>
                  {contacts.kurator_name !== undefined ? (
                    <div>
                      <div className="pet__curator-text">Куратор</div>
                      <div className="pet__curator-name">
                        {contacts.kurator_name}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              ) : null}
            </Link>
            <div className="pet__curator-tel">{contacts.kurator_phone}</div>
          </div>
        ) : null}
      </div>
    )
  }
}

export default Pet
